<template>
  <div>
    <b-card>
      <div class="text-center">
        <div>
          PRÉVIA DO FORMULÁRIO 
          <br><b>(SÓ EXEMPLO, sem carater funcional)</b>
        </div>
        <div class="mt-2">
          Titulo: <b>{{ propForm.title }}</b>
        </div>
        <div>
          Descrição: <b>{{ propForm.description }}</b>
        </div>
      </div>
      <div class="mt-1">
        <div v-for="(input, indexInput) in propForm.inputs" :key="`question_${indexInput}`">
          <div class="row">
            <div v-if="input.question && input.type" class="col-12 mb-1">
              <b>
                <label :for="`question_${indexInput}`">{{ input.question }}</label>
              </b>
              <b-input v-if="input.type == 'short_text'" :id="`question_${indexInput}`" />
              <b-textarea v-if="input.type == 'long_text'" :id="`question_${indexInput}`" />
              <b-form-file v-if="input.type == 'unique_image'" :id="`question_${indexInput}`" />
              <b-card v-if="input.type == 'many_image'" :id="`question_${indexInput}`" class="border text-center">
                <feather-icon icon="UploadIcon" size="32" />
                <br>
                Suba várias fotos
              </b-card>
              <b-form-radio-group
                v-if="input.type == 'unique_choose'"
                :id="`question_${indexInput}`"
                class="mt-1"
                :options="input.options" />
              <b-form-checkbox-group
                v-if="input.type == 'many_choose'"
                :id="`question_${indexInput}`"
                class="mt-1"
                :options="input.options" />
              
              <b-form-checkbox
                v-if="input.type == 'yes_no'"
                class="custom-control-success form-control-sm"
                switch>
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'FormsPreview',
  props: {
    propForm: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>